module.exports = __webpack_public_path__ + "static/assets/963428f9bb3171ce09fe9efd4cb071a0.svg";